var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.partitionList
    ? _c("table", [
        _c("caption", [_vm._v("\n    " + _vm._s(_vm.title) + "\n  ")]),
        _vm._v(" "),
        _vm._m(0),
        _vm._v(" "),
        _c(
          "tbody",
          _vm._l(_vm.partitionList, function(partition) {
            return _c("tr", { key: partition.key }, [
              _c("td", [_vm._v(_vm._s(partition.ownerHostName))]),
              _vm._v(" "),
              _c("td", [_vm._v(_vm._s(partition.key))])
            ])
          }),
          0
        )
      ])
    : _vm._e()
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", [
      _c("th", [_vm._v("Host name")]),
      _vm._v(" "),
      _c("th", [_vm._v("Partition")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-85df9d2c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-85df9d2c","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/routes/task-list/components/partition-table.vue
// module id = 1740
// module chunks = 0